<template>
    <div>
        <h1 style="font-size: 24px; color: black;">投放中台</h1>
        <el-card shadow="never">
            <el-row type="flex">
                <el-col>
                    <span> 产品分类</span>
                    <el-select v-model="dept" placeholder="请选择" @change="deptChange">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="208" value="1"></el-option>
                        <el-option label="记账" value="2"></el-option>
                        <el-option label="新项目" value="3"></el-option>
                        <el-option label="宠物" value="4"></el-option>
                        <el-option label="暖悦" value="5"></el-option>
                        <el-option label="小游戏" value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 应用：</span>
                    <el-select v-model="queryData.packageName" placeholder="请选择" filterable multiple collapse-tags>
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="app in appList"
                                   :key="app.packageName"
                                   :label="app.appName"
                                   :value="app.packageName"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 媒体</span>
                    <el-select v-model="queryData.platform" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="磁力" value="cili_engine"></el-option>
                        <el-option label="巨量" value="juliang_engine"></el-option>
                        <el-option label="百度" value="baidu_dev2"></el-option>
                        <el-option label="广点通" value="gdt_tx"></el-option>
                        <el-option label="华为" value="shop_huawei"></el-option>
                        <el-option label="小米" value="shop_xiaomi"></el-option>
                        <el-option label="荣耀" value="shop_honor"></el-option>
                        <el-option label="小红书" value="xhs"></el-option>
                        <el-option label="苹果商店asa" value="shop_apple"></el-option>
                        <el-option label="oppo" value="shop_oppo"></el-option>
                        <el-option label="vivo" value="shop_vivo"></el-option>
                        <el-option label="华夏" value="hua_xia"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 日期</span>
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row type="flex">
                <el-col label="1级id：">
                    <span> 使用小写的 , 分割</span>
                </el-col>
                <el-col label="1级id：">
                    <span> 广告主id</span>
                    <el-input v-model="queryData.l1Id" style="width: auto"></el-input>
                </el-col>
                <el-col label="1级id：">
                    <span> 广告主名称</span>
                    <el-input v-model="queryData.l1Name" style="width: auto"></el-input>
                </el-col>
                <el-col label="2级id：">
                    <span> 广告组id</span>
                    <el-input v-model="queryData.l2Id" style="width: auto"></el-input>
                </el-col>
                <el-col label="3级id：">
                    <span> 广告id</span>
                    <el-input v-model="queryData.l3Id" style="width: auto"></el-input>
                </el-col>
                <el-col label="4级id：">
                    <span> 创意id</span>
                    <el-input v-model="queryData.l4Id" style="width: auto"></el-input>
                </el-col>
            </el-row>
            <el-row>投放人员
                <el-select v-model="queryData.lcName" placeholder="请选择" filterable>
                    <el-option label="张瀛旭" value="张瀛旭"></el-option>
                    <el-option label="卓敏敏" value="卓敏敏"></el-option>
                    <el-option label="罗桦" value="罗桦"></el-option>
                </el-select>
            </el-row>
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <el-button type="primary" @click="searchc">查询</el-button>
                    <el-button type="primary" @click="clear">清空</el-button>
                    <el-button type="primary" @click="exportExcel" :disabled="!isExport">导出</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-tabs type="border-card" @tab-click="changeIndex" v-model="level">
            <el-tab-pane label="总数据" name="9"></el-tab-pane>
            <el-tab-pane label="产品" name="0"></el-tab-pane>
            <el-tab-pane label="媒体" name="5"></el-tab-pane>
            <el-tab-pane label="账户" name="1"></el-tab-pane>
            <el-tab-pane label="广告组" name="2"></el-tab-pane>
            <el-tab-pane label="广告" name="3"></el-tab-pane>
            <!--            <el-tab-pane label="创意" name="4"></el-tab-pane>-->
            <h1>
                <el-table :data="datas" border :fit="true" :key="tableKey" @sort-change='sortChange' height="calc(100vh - 260px)">

                <el-table-column key="1" label="状态" prop="status" v-if="level==='3'"></el-table-column>
                    <el-table-column key="2" label="操作" v-if="level==='3'">
                        <template slot-scope="scope">
                            <el-button plain size="mini" type="primary" @click="edit(scope.row,1)">投放
                            </el-button>
                            <el-button plain size="mini" type="primary" @click="edit(scope.row,0)">暂停
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column key="3" label="日期" prop="dt" sortable="custom"
                                     v-if="level==='0'||level==='5'||level==='1'||level==='2'||level==='3'||level==='4'"></el-table-column>
                    <el-table-column key="4" label="产品" prop="packageName"
                    ></el-table-column>
                    <el-table-column key="5" label="媒体" prop="platform"
                                     v-if="level==='1'||level==='2'||level==='3'||level==='4'||level==='5'"
                    ></el-table-column>
                    <el-table-column key="6" label="账户id" prop="l1id"
                                     v-if="level==='1'||level==='2'||level==='3'||level==='4'"></el-table-column>
                    <el-table-column key="7" label="账户名称" prop="l1name"
                                     v-if="level==='1'||level==='2'||level==='3'||level==='4'"></el-table-column>
                    <el-table-column key="8" label="广告组id" prop="l2id" v-if="level==='2'"></el-table-column>
                    <el-table-column key="9" label="广告组名称" prop="l2name" v-if="level==='2'"></el-table-column>
                    <el-table-column key="10" label="广告id" prop="l3id" v-if="level==='3'"></el-table-column>
                    <el-table-column key="11" label="广告名称" prop="l3name" v-if="level==='3'"></el-table-column>
                    <el-table-column key="12" label="单日预算" prop="budget" v-if="level==='3'"
                    ></el-table-column>
                    <el-table-column key="14" label="创意id" prop="l4id" v-if="level==='4'"></el-table-column>
                    <el-table-column key="15" label="创意名称" prop="l4name" v-if="level==='4'"></el-table-column>
                    <el-table-column key="16" label="出价" prop="bid" v-if="level==='3'"></el-table-column>
                    <el-table-column key="17" label="花费" prop="charge" sortable="custom"></el-table-column>
                    <el-table-column key="18" label="t0归因收入" prop="t0incomeAttr"></el-table-column>
                    <el-table-column key="19" label="t0全部收入" prop="t0incomeAll"
                                     v-if="(queryData.platform==null||queryData.platform==='')&&(level==='9'||level==='0')"></el-table-column>
                    <el-table-column key="72" label="t0归因付费" prop="paySumReala"></el-table-column>
                    <el-table-column key="73" label="t0全部付费" prop="paySumRealAll"
                                     v-if="(queryData.platform==null||queryData.platform==='')&&(level==='9'||level==='0')"></el-table-column>
                    <el-table-column key="20" label="首日roi" prop="roi0"></el-table-column>
                    <el-table-column key="22" label="媒体激活数" prop="active"></el-table-column>
                    <el-table-column key="23" label="媒体激活成本" prop="chargeActive"></el-table-column>
                    <el-table-column key="24" label="归因激活数" prop="rn1s"></el-table-column>
                    <el-table-column key="25" label="归因激活成本" prop="chargeRn1"></el-table-column>
                    <el-table-column key="70" label="全量激活数" prop="rnAll1s"
                                     v-if="(queryData.platform==null||queryData.platform==='')&&(level==='9'||level==='0')"></el-table-column>
                    <el-table-column key="71" label="全量激活成本" prop="chargeRnAll1"
                                     v-if="(queryData.platform==null||queryData.platform==='')&&(level==='9'||level==='0')"></el-table-column>
                    <el-table-column key="26" label="ltv0" prop="ltv0"></el-table-column>
                    <el-table-column key="28" label="ecpm0" prop="ecpm0"></el-table-column>
                    <el-table-column key="30" label="ipu0" prop="ipu0"></el-table-column>
                    <el-table-column key="31" label="关键行为数" prop="keyBehavior"></el-table-column>
                    <el-table-column key="32" label="关键行为成本" prop="chargeKeyBehavior"></el-table-column>
                    <el-table-column key="33" label="关键行为率" prop="keyBehaviorRn1"></el-table-column>
                    <el-table-column key="34" label="次留数" prop="rn2"></el-table-column>
                    <el-table-column key="35" label="次留成本" prop="chargeR1"></el-table-column>
                    <el-table-column key="36" label="代理" prop="agentId"
                                     v-if="level==='4'"></el-table-column>
                    <el-table-column key="37" label="余额" prop="balance"
                                     v-if="level==='4'"></el-table-column>
                    <el-table-column key="38" label="公司投放人员名" prop="lcName"></el-table-column>
                    <el-table-column key="39" label="点击率" prop="clickRate"></el-table-column>
                    <el-table-column key="40" label="平均千次展示费用" prop="cpm"></el-table-column>
                    <el-table-column key="41" label="次留" prop="rn2Rn1"></el-table-column>
                    <el-table-column key="42" label="3留" prop="rn3Rn1"></el-table-column>
                    <el-table-column key="43" label="4留" prop="rn4Rn1"></el-table-column>
                    <el-table-column key="44" label="5留" prop="rn5Rn1"></el-table-column>
                    <el-table-column key="45" label="6留" prop="rn6Rn1"></el-table-column>
                    <el-table-column key="46" label="7留" prop="rn7Rn1"></el-table-column>
                    <el-table-column key="47" label="14留" prop="rn14Rn1"></el-table-column>
                    <el-table-column key="48" label="30留" prop="rn30Rn1"></el-table-column>
                    <el-table-column key="49" label="60留" prop="rn60Rn1"></el-table-column>
                    <el-table-column key="50" label="ltv1" prop="ltv1"></el-table-column>
                    <el-table-column key="51" label="ltv2" prop="ltv2"></el-table-column>
                    <el-table-column key="52" label="ltv3" prop="ltv3"></el-table-column>
                    <el-table-column key="53" label="ltv4" prop="ltv4"></el-table-column>
                    <el-table-column key="54" label="ltv5" prop="ltv5"></el-table-column>
                    <el-table-column key="55" label="ltv6" prop="ltv6"></el-table-column>
                    <el-table-column key="56" label="ltv7" prop="ltv7"></el-table-column>
                    <el-table-column key="57" label="ltv14" prop="ltv14"></el-table-column>
                    <el-table-column key="58" label="ltv30" prop="ltv30"></el-table-column>
                    <el-table-column key="59" label="ltv60" prop="ltv60"></el-table-column>
                    <el-table-column key="60" label="roi1" prop="roi1"></el-table-column>
                    <el-table-column key="61" label="roi2" prop="roi2"></el-table-column>
                    <el-table-column key="62" label="roi3" prop="roi3"></el-table-column>
                    <el-table-column key="63" label="roi4" prop="roi4"></el-table-column>
                    <el-table-column key="64" label="roi5" prop="roi5"></el-table-column>
                    <el-table-column key="65" label="roi6" prop="roi6"></el-table-column>
                    <el-table-column key="66" label="roi7" prop="roi7"></el-table-column>
                    <el-table-column key="67" label="roi14" prop="roi14"></el-table-column>
                    <el-table-column key="68" label="roi30" prop="roi30"></el-table-column>
                    <el-table-column key="69" label="roi60" prop="roi60"></el-table-column>
                    <el-table-column key="74" label="t0归因笔数" prop="payCounta"></el-table-column>
                    <el-table-column key="75" label="t0全部笔数" prop="payCountAll"
                                     v-if="(queryData.platform==null||queryData.platform==='')&&(level==='9'||level==='0')"></el-table-column>
                </el-table>
            </h1>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[100,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>

        </el-tabs>
    </div>
</template>

<script>
import {downloadData, middleEdit, middleReport} from "@/http/outApi";
import settingMix from "@/utils/mix/common-setting";
import utils from "@/utils";

export default {
    name: "FcReport",
    mixins: [settingMix],
    data() {
        return {
            dept: null,
            appList: [],
            needGetApp: true,
            checkAll: false,
            headers: {},
            datas: [],
            tableKey: 1,
            level: "1",
            page: {
                size: 100,
                page: 1,
                totalElements: null,
                isExpense: false
            },
            table: {
                l1name: null,
            },
            queryData: {
                timeDate: ['', '']
            },
            queryRuleReq: {
                size: 10000
            },
            isExport: true
        }
    },
    methods: {
        search() {
            this.queryData.page = this.page.page;
            this.queryData.size = this.page.size;
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.queryData.level = this.level;
            this.queryData.excel = false;
            middleReport(this.queryData).then(resp => {
                this.datas = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements
            })
        },
        edit(data, b) {
            data.b = b;
            middleEdit(data).then(() => {
                this.search();
            })
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.search();
        },
        searchc() {
            this.page.page = 1;
            this.search();
        },
        changeIndex: function (tab) {
            this.level = tab.name;
            this.page.page = 1;
            this.search();
        },
        sortChange(order) {
            this.queryData.order = order.order;
            this.queryData.prop = order.prop;
            this.search();
        },
        exportExcel() {
            this.isExport = false;
            let l = '';
            switch (this.level) {
                case "9":
                    l = "总数据";
                    break;
                case "0":
                    l = "产品";
                    break;
                case "5":
                    l = "媒体";
                    break;
                case "1":
                    l = "账户";
                    break;
                case "2":
                    l = "广告组";
                    break;
                case "3":
                    l = "广告";
                    break;
                case "4":
                    l = "创意";
                    break;
            }
            let fileName = new Date().toLocaleString() + l + '报告.xlsx';
            downloadData(
                '/middle/reportExcel',
                this.queryData,
                fileName
            ).then(resp => {
                console.log(resp);
                this.isExport = true;
            })
        },
        deptChange() {
            var list = [];
            for (var x in this.appList) {
                if (this.appList[x].dept + "" === this.dept + "" || this.dept === '') {
                    list.push(this.appList[x].packageName)
                }
            }
            this.queryData.packageName = list;
        },
        clear() {
            this.dept = null;
            this.queryData.packageName = [];
            this.queryData.platform = null;
            this.queryData.l1Id = null;
            this.queryData.l2Id = null;
            this.queryData.l3Id = null;
            this.queryData.l4Id = null;
            this.queryData.l1Name = null;
        },
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.queryData.timeDate = [utils.TodayUtil.getToday(), utils.TodayUtil.getToday()];
        this.search();
    },
    mounted() {
        this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }
}
</script>

<style scoped>

</style>
